module.exports = __webpack_public_path__ + "img/3aw-693.6d126de6.png";